export const ERROR_CODE_SUCCESS = "000000";
